var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4H6.5C5.4 4 4.5 4.9 4.5 6V16C4.5 17.1 5.4 18 6.5 18H16.5C17.6 18 18.5 17.1 18.5 16V6C18.5 4.9 17.6 4 16.5 4ZM16.5 6V8H6.5V6H16.5ZM10.5 12V10H12.5V12H10.5ZM12.5 14V16H10.5V14H12.5ZM8.5 12H6.5V10H8.5V12ZM14.5 10H16.5V12H14.5V10ZM6.5 14H8.5V16H6.5V14ZM14.5 16V14H16.5V16H14.5ZM3.5 14H2.5C1.4 14 0.5 13.1 0.5 12V2C0.5 0.9 1.4 0 2.5 0H12.5C13.6 0 14.5 0.9 14.5 2V3H12.5V2H2.5V12H3.5V14Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleList);
export default __webpack_public_path__ + "static/media/Schedule-List.7c309c0e88d306e24a5eedea2af79288.svg";
export { ForwardRef as ReactComponent };